<template>
  <div>
    <div>
      <input-qr-scan-model
        v-model="code"
        ref="codeRef"
        label="Quét Xe | Chìa khóa | Mũ | Sạc"
        @keyupEnter="scanInput"
      ></input-qr-scan-model>
    </div>
    <div>
      <v-simple-table class="table-padding-2 table-h-36 mt-3">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Tạo</th>
              <th role="columnheader" class="text-center">Trạng thái</th>
              <th role="columnheader" class="text-center">Xe</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="`r_${index}_${item.id}`"
              class="text-center"
            >
              <td>
                {{ formatDateTime(item.created_at) }}
              </td>
              <td>{{ item.status_text }}</td>
              <td>{{ item.asset_uid_name }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-dialog v-model="dialogConfirm" persistent max-width="420px">
      <CreateReturnRequest
        v-if="dialogConfirm"
        :order="order"
        @close="hideConfirmDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ORDER_DELIVERY_STATUSES } from "@/libs/const";
import { httpClient } from "@/libs/http";

export default {
  name: "DeliveryRequestPartner",
  components: {
    CreateReturnRequest: () => import("@/components/rent/CreateReturnRequest"),
  },
  data: () => ({
    items: [],
    code: null,
    order: {},
    isLoading: false,
    dialogConfirm: false,
  }),
  computed: {},
  mounted() {
    this.getList();
  },
  methods: {
    showConfirmDialog() {
      this.dialogConfirm = true;
    },
    hideConfirmDialog() {
      this.order = {};
      this.dialogConfirm = false;
      this.getList();
    },
    async getList() {
      const { data } = await httpClient.post(
        "/order/v1/delivery-request-partner-get-list"
      );
      this.items = [...data].map((item) => {
        const deliveryStatus = [...ORDER_DELIVERY_STATUSES].find(
          (d) => d.value == item.status
        );
        return {
          ...item,
          status_text: deliveryStatus.text,
        };
      });
    },

    async scanInput() {
      if (!this.code) {
        return false;
      }

      const code = this.code.toUpperCase();

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("Loading"));
        return false;
      }

      this.isLoading = true;

      try {
        const { data } = await httpClient.post(
          "/order/v1/delivery-request-partner-get-order-by-code",
          {
            code: code,
          }
        );
        this.code = null;
        this.isLoading = false;

        this.order = { ...data };
        this.showConfirmDialog();

        document.getElementById("success_sound_player").play();
      } catch (e) {
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
        this.code = null;
        this.isLoading = false;
        document.getElementById("error_sound_player").play();
      }
    },
  },
};
</script>
